import React from 'react'

const PatientEducation = () => {
  return (
    <div className='mx-auto p-4'>
      PatientEducation
    </div>
  )
}

export default PatientEducation
